<template>
  <v-container fluid>
    <h1>Help</h1>
    <p>
      Zoek je hulp bij de app? Kijk in het menu onder 'help & contact'
    </p>
  </v-container>
</template>

<script>
export default {
  metaInfo: {
    title: 'Help'
  },
}
</script>

<style>

</style>
